import { post } from '@http/request'

/**
 * 列表
 * @param data
 * @returns {*}
 */
export const reqList = (data) => post('vip/collectionfeeApply/getPagesByConditionBillApply', data)

/**
 * 申请返款
 * @param data
 * @returns {*}
 */
export const fetchApplyRefund = (data) => post('vip/collectionfeeApply/apply', data)

/**
 * 汇总
 * @param data
 * @returns {*}
 */
export const fetchSummary = (data) => post('vip//collectionfeeApply/newApplySum', data)
